import React from 'react';
import rightChev from '../../../../assets/images/chev-right-royal.svg';
import { joinClasses } from '../../../../utils/helpers';

/** @import { CarouselArrowProps } from '../../DashboardNewTypes' */

/**
 * Next arrow component for the account carousel
 * @param {CarouselArrowProps} props
 */
const NextArrow = ({ onClick, enabled = true, visible = true }) => (
    <img
        src={rightChev}
        className={joinClasses(
            'account-carousel__arrow', 
            'account-carousel__arrow--next', 
            visible ? '' : 'account-carousel__arrow--invisible'
        )}
        onClick={enabled ? onClick : undefined}
        alt="Next"
    />
);

export default NextArrow;
